import React, { useCallback, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import Loader from '../../../components/common/Loader';
import { GLOBAL_DEFAULT } from '../../../constants/global';
import { orderService } from '../services';
import { applyOrdersArchiveRecipientWarehouse, toOrdersArray } from './thermal/orderPrintNormalize';
import PaginatedPackingSlipOrder from './thermal/PaginatedPackingSlipOrder';
import './thermal/printPackingSlipPeel.scss';
import { useThermalPrintViewSetup } from './thermal/useThermalPrintViewSetup';

const PrintPackagingSlip: React.FC<any> = () => {
    const [state, setState] = useState<any>(null);
    const [orderDetail, setOrderDetail] = useState<any>();
    const [loading, setLoading] = useState<boolean>(GLOBAL_DEFAULT.LOADER_STATE);

    useEffect(() => {
        try {
            const windowName = window.name;
            const state = JSON.parse(windowName);

            setState(state);
        } catch (error) {
            console.error('Failed to parse state from window name', error);
            window.location.href = '/app/dashboard';
        }
    }, []);

    useThermalPrintViewSetup();

    const getOrderDetail = useCallback(async () => {
        if (state?.orderId) {
            setLoading(true);
            try {
                const payload = {
                    orderIds: state?.orderId,
                    type: state?.orderType || 'Orders',
                };
                const response = await orderService.printPackingSlip(payload);

                if (state?.orderType === 'OrdersArchive') {
                    applyOrdersArchiveRecipientWarehouse(response?.data);
                }

                setOrderDetail(response?.data);
                setLoading(false);
            } catch (error) {
                setLoading(false);
            }
        }
    }, [state?.orderId, state?.orderType]);

    useEffect(() => {
        getOrderDetail();
    }, [getOrderDetail]);

    const orders = toOrdersArray(orderDetail);

    return (
        <>
            <Loader isLoading={loading} />
            <div className="text-center hide-on-print py-3 ">
                <Button
                    className="custom-min-width-85"
                    size="sm"
                    variant="dark"
                    onClick={() => window.print()}
                >
                    Print
                </Button>
            </div>
            {orders.map((order: any, index: number) => (
                <PaginatedPackingSlipOrder key={order?.order_number ?? index} order={order} />
            ))}
        </>
    );
};

export default PrintPackagingSlip;